import { ICommand } from 'core-ts-types';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';

class DiscardDraftPopup {
  private open: boolean;
  constructor(
    private $state: ng.ui.IStateService,
    private $element: ng.IAugmentedJQuery,
    private $timeout: ng.ITimeoutService,
    private ngAPNotificationDelegate: INotificationDelegate,
    private deleteSuggestedPlanCommand: ICommand
  ) {}

  openedChanged() {
    this.open = false;
  }
  confirmDiscard() {
    this.open = false;
    this.deleteSuggestedPlanCommand()
      .then(() => {
        this.ngAPNotificationDelegate.success(`Successfully deleted your suggestions draft.`);
        this.$state.go('ap-advisor.plan', {}, { reload: true });
      })
      .catch(() => {
        this.ngAPNotificationDelegate.success(`Unable to delete your suggestions draft.`);
      });
  }
}

angular.module('capability-ng-academic-planner').component('discardDraftPopup', {
  templateUrl:
    'capability-ng-academic-planner/src/advisor_header/components/discard_draft_popup/discard_draft_popup.html',
  controller: DiscardDraftPopup,
  bindings: {
    open: '='
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/discard_draft_popup/discard_draft_popup.ts